import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions, buildDropdownAudit} from '../../../reusable'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'

import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons'
import {Tr} from '../../../_metronic/i18n/Tr'
import Select, { CSSObjectWithLabel } from 'react-select'

const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

 const Popup = (props: any) => {
    let t = Tr()


    const [enTitle, setEnTitle] = useState('')
    const [ruTitle, setRuTitle] = useState('')
    const [uzTitle, setUzTitle] = useState('')
    const [selectedType, setSelectedType] = useState('') as any
    const [oldType, setOldType] = useState<any>(null)
    const [error, setError] = useState(Object)
    const [disable, setDisable] = useState(false)
    const [typeList] = useState([
      {label: 'USER', value: 'USER'},
      {label: 'VENDOR', value: 'VENDOR'},
    ])

    const saveHelpAndSupportSubject = async () => {
      setDisable(true)

      let param: any = {
        en_title: enTitle.trim(),
        ru_title: ruTitle.trim(),
        uz_title: uzTitle.trim(),
        type: selectedType,
        adminId: adminId,
        
      }

      if (props.helpandsupportsubjectId != '' && props.helpandsupportsubjectId != '0') {
        param.helpandsupportsubjectId = props.helpandsupportsubjectId
      }

      var res = await fetchData('admin/savesubject', param)
      if (res.status == '200') {
        toastsuccessmsg(res.message)

        setDisable(false)
        props.onHide()
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
    const validate = () => {
      var errotmp: any = {}
      var err = 0
      if (enTitle.trim() == '' || enTitle.trim() == null || enTitle.trim() == undefined) {
        errotmp['enTitleError'] = t('Subject English Name Is Required')
        err = 1
      } else if (enTitle.trim().length > 50) {
        errotmp['enTitleError'] = t('Subject English Name Is Too Large')
        err = 1
      }
      if (ruTitle != null && ruTitle.trim().length > 50) {
        errotmp['ruTitleError'] = t('Subject russian Name Is Too Large')
        err = 1
      }
      if (uzTitle != null && uzTitle.trim().length > 50) {
        errotmp['uzTitleError'] = t('Subject Uzbek Name Is Too Large')
        err = 1
      }
      if (selectedType == null || selectedType.trim() == '' || selectedType.trim() == undefined) {
        errotmp['typeError'] = t('Type Is Required')
        err = 1
      }

      setError(errotmp)
      if (err == 0) {
        saveHelpAndSupportSubject()
      }
    }
    
    const helpAndSupportSuibjectDetail = async (catlist: any) => {
      var param = {
        helpandsupportsubjectId: props.helpandsupportsubjectId,
      }
      var res = await fetchData('admin/viewsubject', param)
      if (res.status == '200') {
        var data = res.data[0]

        setEnTitle(data.en_title)
        setRuTitle(data.ru_title)
        setUzTitle(data.uz_title)
        setSelectedType(data.type)
        setOldType(typeList.find((o: any) => o.value === data.type) || null)
      } else {
        toasterrormsg(res.message)
      }
    }

    useEffect(() => {
      if (props.helpandsupportsubjectId > 0) {
        helpAndSupportSuibjectDetail(props.helpandsupportsubjectId)
      }
    }, [])

    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>
              {props.helpandsupportsubjectId !== '' &&
              props.helpandsupportsubjectId !== null &&
              props.helpandsupportsubjectId > '0'
                ? t('Edit')
                : t('Add')}{' '}
              {t('Help & Support Subject')}
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className='stepper stepper-links d-flex flex-column'
            id='kt_create_account_stepper'
            data-kt-stepper='true'
          >
            <div className='mx-auto mw-600px w-100 py-10' id='kt_create_account_form'>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('Select Type')}
                </label>
                <Select
                  name='selectType'
                  id='selectType'
                  placeholder={t('Select Type')}
                  isSearchable={true}
                  options={typeList}
                  value={typeList.find((option: any) => option.value === selectedType) || null}
                  onChange={(e: any) => {
                    setSelectedType(e.value)
                  }}
                  menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
                  styles={{
                    menuPortal: (base:CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
                    menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
                  }}
                />
                <label className='text-danger'>{error.typeError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('English Name')}
                </label>
                <input
                  type='text'
                  name='ticketSubjectTitle'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('English Name')}
                  value={enTitle}
                  onChange={(e: any) => setEnTitle(e.target.value)}
                ></input>
                <label className='text-danger'>{error.enTitleError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>{t('Russian Name')}</label>
                <input
                  type='text'
                  name='ticketSubjectTitle'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('Russian Name')}
                  value={ruTitle}
                  onChange={(e: any) => setRuTitle(e.target.value)}
                ></input>
                <label className='text-danger'>{error.ruTitleError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>{t('Uzbek Name')}</label>
                <input
                  type='text'
                  name='ticketSubjectTitle'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('Uzbek Name')}
                  value={uzTitle}
                  onChange={(e: any) => setUzTitle(e.target.value)}
                ></input>
                <label className='text-danger'>{error.uzTitleError || ''}</label>
              </div>

              {/* action button start */}
              <div className={`d-flex pt-15 justify-content-center`}>
                <button
                  type='button'
                  className={`btn btn-lg btn-light-success me-3`}
                  onClick={props.onHide}
                >
                  {t('Cancel')}
                </button>

                <button
                  type='button'
                  disabled={disable}
                  className={`btn btn-lg btn-success monthBtn me-3`}
                  onClick={() => validate()}
                >
                  {!disable && t('Save')}
                  {disable && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

function ViewTicketSubjects() {
  let t = Tr()
    const {menuIdAdd, menuIdEdit, menuIdDelete} = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [helpAndSupportSubjectList, setHelpAndSupportSubjectList] = useState([])
  const [orgHelpAndSupportSubjectList, setOrgHelpAndSupportSubjectList] = useState([])
  const [helpandsupportsubjectId, setHelpandsupportsubjectId] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)

 

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('English Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_title}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_title),
      },
      {
        name: t('Russian Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_title}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_title),
        filter: true,
      },
      {
        name: t('Uzbek Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_title}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_title),
        filter: true,
      },
      {
        name: t('Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.type}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.type),
        filter: true,
      },

      {
        name: t('Action'),
        cell: (row: any) => (
          <>
         { menuIdEdit ?  <button
              className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
              title='Edit'
              onClick={() => {
                setShowPopup(true)
                setHelpandsupportsubjectId(row.helpandsupportsubjectId)
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button> :""}

         {menuIdDelete?   <button
              className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
              title='delete'
              onClick={() => deleteTicketSubject(row.helpandsupportsubjectId)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button> :""}
          </>
        ),
      },
    ],
    [t]
  )

  const deleteTicketSubject = async (helpandsupportsubjectId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete This Help & Support Subject!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          var param: any = {
            typeId: String(helpandsupportsubjectId),
            type: 'helpandsupportsubject',
            adminId: adminId,
          }

          const response = await fetchData('admin/deleteMasterData', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            helpandsupportsubjectListApiCall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  // call ticket subject list api
  const helpandsupportsubjectListApiCall = async () => {
    var param: any = {}
    var response: any = await fetchData('admin/viewsubject', param)

    if (response.status == '200') {
      
      setHelpAndSupportSubjectList(response.data)
      setOrgHelpAndSupportSubjectList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | View Help & Support Subjects'
    helpandsupportsubjectListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Ticket Subjects')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
         {menuIdAdd ? <button type='button' className='btn btn-success' onClick={() => setShowPopup(true)}>
            <KTIcon iconName='plus' className='fs-2' />
            {t('Add Help & Support Subjects')}
          </button> :""}
        </div>
      </div>
    )
  }

  //search function
  const ticketSubjectSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setHelpAndSupportSubjectList(orgHelpAndSupportSubjectList)
    } else {
      var tmp: any = orgHelpAndSupportSubjectList.filter(
        (item: any) =>
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase() == text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.type != null &&
            item.type != '' &&
            item.type.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name == text) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name.includes(text)) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name == text) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name.includes(text))
      )

      setHelpAndSupportSubjectList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgHelpAndSupportSubjectList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={helpAndSupportSubjectList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader
                      search={searchTerm}
                      isfoc={focus}
                      customSearch={ticketSubjectSearch}
                    />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold '>
                      {t('Welcome To Help & Support Subject')}
                    </h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold '>
                    {t('There are no Help & Support Subject')}
                  </p>
               {menuIdAdd ?   <Link
                    to='#'
                    className='btn btn-success monthBtn'
                    onClick={() => setShowPopup(true)}
                  >
                    {t('Add Help & Support Subjects')}
                  </Link> :""}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            onHide={() => {
              setShowPopup(false)
              setHelpandsupportsubjectId('0')
                      helpandsupportsubjectListApiCall()

            }}
            helpandsupportsubjectId={helpandsupportsubjectId}
          />
        )}
      </div>
    </>
  )
}

export default ViewTicketSubjects
